import { render } from "./matching-card-thumbnail.vue?vue&type=template&id=5dd2bf7b&scoped=true&ts=true"
import script from "./matching-card-thumbnail.vue?vue&type=script&lang=ts"
export * from "./matching-card-thumbnail.vue?vue&type=script&lang=ts"

import "./matching-card-thumbnail.vue?vue&type=style&index=0&id=5dd2bf7b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd2bf7b"]])

export default __exports__